<template>
  <div >
    <div v-if="item">
      <div v-if="!noPicAvailable" class="resContainer"
        :style="'height:' + defaultWidth + 'px;width: '+computedWidth + 'px' " @mouseenter="handleEnter" @mouseleave="showOverlay = false">
        <div v-if="loading" class="loading-container">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div  :id="imgViewerName" ref="viewer" class="osd-viewer"         @click="handleClick"
        ></div>
        <div
          v-if="isTouchDevice"
          @touchstart="handleTouchStart"
          @touchmove="handleTouchMove"
          @touchend="handleTouchEnd"
          @mouseenter="showOverlay = true"
          @mouseleave="showOverlay = false"
          @click="handleClick"
          class="touch-overlay"> </div>
          <transition name="overlay-slide" appear>
        <div
          v-show="showOverlay"
          ref="mouseWheelOverlayIMG"
          class="overlay"
        >
            <a
              :href="buildLink()"
              target="_blank"
              class="overlay-link"

            >
              {{ item.label }}
            </a>
        </div>
        </transition>
      </div>
      <div class="resContainer nopic-container" :style="'height:' + defaultWidth + 'px;width: '+computedWidth + 'px' " ref="test" v-if="noPicAvailable" >
        <a :href="buildLink()" target=”_blank” class=" px-1 no-pic-overlay">
          <div v-html="item.label"></div>
        </a>
      </div>
    </div>
    <div class="d-flex justify-center align-content-center" v-else>
      <div class="resContainer nopic-container d-flex align-center justify-center" :style="'height:' + defaultWidth + 'px;width: '+computedWidth + 'px' " ref="test" >
        <v-progress-circular class="align-content-center " :size="defaultWidth/2"  indeterminate color="primary"></v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
import { getOSDURL, getOSDURLCave, isMobile } from "../utils/helpers";
const OpenSeadragon = window.OpenSeadragon;
const Annotorious = window.Annotorious;
const SelectorPack = window.AnnotoriousSelectorPack;
console.log("OSD", OpenSeadragon, Annotorious, SelectorPack);
export default {
  props: {
    item: {
      type: Object,
    }

  },
  data() {
    return {
      showOverlay: false,
      defaultWidth: 300,
      computedWidth: 300,
      viewerImg: null,
      annotoriousplugin: null,
      noPicAvailable: false,
      pressTimer: null,
      longPressThreshold: 500, // Dauer in Millisekunden (z. B. 500ms = 0,5 Sek.)
      loading: true, // NEU: Standardmäßig auf "true"
      touchStartY: 0,
      touchStartX: 0,
      touchMoved: false,
      moveThreshold: 10 // px
    };
  },
  computed: {
    imgViewerName() {
      if (!this.item) return ''
      return "tile-" + this.item.itemType + "-" + this.item.itemID
    },
    isTouchDevice() {
      return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
    },

  },
  methods: {
    handleEnter() {
      requestAnimationFrame(() => {
        this.showOverlay = true;
      });
    },
    handleTouchStart(event) {
      const touch = event.touches[0];
      this.touchStartY = touch.clientY;
      this.touchStartX = touch.clientX;
      this.touchMoved = false;
    },
    handleTouchMove(event) {
      const touch = event.touches[0];
      const dy = Math.abs(touch.clientY - this.touchStartY);
      const dx = Math.abs(touch.clientX - this.touchStartX);

      if (dy > this.moveThreshold || dx > this.moveThreshold) {
        this.touchMoved = true;
      }
    },
    handleTouchEnd() {
      // Wenn bewegt wurde → war Scroll → nichts tun
      if (this.touchMoved) {
        return;
      }

      // echtes Tap-Verhalten:
      if (!this.showOverlay) {
        this.showOverlay = true;

        this.overlayTapTimer = setTimeout(() => {
          this.showOverlay = false;
        }, 3000);
      } else {
        window.open(this.buildLink(), '_blank');
      }
    },
    preventTouchScroll(event) {
      // Verhindert, dass das Scrollen von mobilen Geräten blockiert wird
      // event.preventDefault();
    },
    startLongPress() {
      if (!this.isTouchDevice) return; // Falls kein Touchscreen, Long Press ignorieren
      this.longPressTriggered = false;
      this.longPressTimer = setTimeout(() => {
        this.longPressTriggered = true;
        window.open(this.buildLink(), "_blank");
      }, 800); // Link wird nach 800ms ausgeführt
    },
    endLongPress() {
      clearTimeout(this.longPressTimer);
    },
    cancelLongPress() {
      if (this.isTouchDevice && this.actControl === "Explore"){
        const top = this.clientY - event.changedTouches[0].screenY
        window.scrollBy(0, top)
      }
      clearTimeout(this.longPressTimer);
    },
    handleClick(event) {
      if (event.pointerType === "touch") {
        this.$log.debug("is touch");
        return
      }
      // Auf Desktop soll der Klick normal durchgehen
      window.open(this.buildLink(), '_blank');
    },
    toggleOverlay() {
      this.showOverlay = !this.showOverlay;
    },
    buildLink() {
      if (this.item.link) return this.item.link
      let link = "/" + this.item.itemType + "/" + this.item.itemID
      let linkparams = "?"
      if (this.item && this.item?.preSelected?.length > 0 && this.item?.preSelected !== undefined) {
        for (let ico of this.item.preSelected) {
          for (let body of ico.body) {
            if (linkparams.length > 1) {
              linkparams += "&"
            }
            linkparams += ("annottions=" + body.id)
          }
        }
        if (linkparams.length > 1) {
         link += linkparams
        }

      }
      this.$log.debug("buildLink", link)
      return link
    }
  },
  mounted() {
    if (isMobile()) {
      this.showOverlay = true
    }
    if (!this.item) return;
    this.$log.debug("tile mounted", this.item, this.$store.state.user.sessionID, this.item)
    if (this.item.itemType === "bibliography") {
      this.computedWidth = (window.screen.width < 500) ? window.screen.width : 500
    }
    if (window.screen.width < this.defaultWidth) {
      this.computedWidth = window.screen.width
    }
    if (this.item.masterImage && Object.keys(this.item.masterImage).length > 0 && ((this.item.masterImage.accessLevel === 2) || (this.$store.state.user.sessionID && this.item.masterImage.accessLevel > 0)) ) {
      let tilesImg
      if (this.item.itemType === "pr" || this.item.itemType === "iconography") {
        tilesImg = getOSDURL(this.item.masterImage)
      } else if (this.item.itemType === "cave") {
        tilesImg = getOSDURLCave(this.item.masterImage)
      }
      this.$log.debug("tilesImg", tilesImg)
      this.viewerImg = OpenSeadragon({
        id: this.imgViewerName,
        prefixUrl: '/static/',
        tileSources: tilesImg,
        showNavigationControl: false,
        showNavigator: false,
        showZoomControl: false,
        mouseNavEnabled: false,
        handleGesture: true,
        zoomPerScroll: false, // Scroll-Zoom deaktivieren
        minZoomLevel: 1, // Keine ungewollte Vergrößerung
        defaultZoomLevel: 1, // Start-Zoom auf 1 setzen
        tileRequestHeaders: {"Authorization": this.user.sessionID ? `Bearer ${this.user.sessionID}` : ""},
        ajaxHeaders: {"Authorization": this.user.sessionID ? `Bearer ${this.user.sessionID}` : ""},
      })
      const canvases = document.getElementsByClassName('openseadragon-canvas')
      for (const canvas of canvases)  {
        canvas.style.touchAction = 'pan-y'
      }
      const annotationLayers = document.getElementsByClassName('a9s-annotationlayer')
      for (const canvas of annotationLayers){
        canvas.style.touchAction = 'pan-y'
        // canvas.addEventListener('touchstart', this.handleTouchStart);
        // canvas.addEventListener('touchmove', this.handleTouch);
      }
      this.viewerImg.addHandler("open", () => {
        this.$log.debug("opened image")
        const tileSource = this.viewerImg.world.getItemAt(0).source;
        const aspectRatio = tileSource.width / tileSource.height;
        const maxWidth = this.$el.parentElement.offsetWidth * 0.98 // allow groth only to 98% of parent width
        let width = this.defaultWidth * aspectRatio;

        if (width > maxWidth) {
          width = maxWidth;
          this.defaultWidth = width / aspectRatio; // Höhe proportional anpassen
          if (this.defaultWidth < 150){
            this.defaultWidth = 150;
          }

        }

        this.computedWidth = width;

        this.loading = false;
        this.loading = false;
        // const bounds = new OpenSeadragon.Rect(0, 0, 1, 1 / aspectRatio);
        // this.viewerImg.viewport.fitBounds(bounds, true);
      });
      this.viewerImg.addHandler("tile-load-failed", () => {
        this.noPicAvailable = true; // Fallback anzeigen
        this.loading = false; // NEU: Ladeanimation ausblenden
      });
      this.viewerImg.addHandler("open-failed", (event) => {
        this.noPicAvailable = true;
        this.loading = false; // NEU: Ladeanimation ausblenden
      });
      if (this.item &&this.item?.preSelected?.length > 0){
        var MyHighlightFormatter = function(annotation) {
          if (annotation.motivation === "highlight"){
            return {
              'style': 'stroke-width:0px;stroke: gold;  fill: rgba(0, 128, 0,0.25);vector-effect: none;'
            }
          } else {
            return {
              'style': 'stroke-width:0px!important;  fill: rgba(0, 128, 0,0);vector-effect: none;'
            }
          }
        }
        // var MyHighlightFormatter = function(annotation) {
        //   if (annotation.motivation === "highlight"){
        //     return "highlight"
        //   } else {
        //     return "hide"
        //   }
        // }
        const _self = this
        this.viewerImg.addViewerInputHook({ hooks: [
          {tracker: 'viewer',
            handler: 'scrollHandler',
            hookHandler: function (event) {
              _self.$log.debug("scrollHandler");
              // event.preventDefaultAction = true;
              // event.stopHandlers = true;
              // display meta key warning
              _self.toggleOverlay();
              setTimeout(function(){
                _self.toggleOverlay();
              }, 2000);
              return true;
            }
          },
        ]});
        // Handle drag scroll.
        // Only works if touch-action: pan-y else scroll event doesn't propigate to documen
        this.viewerImg.addViewerInputHook({ hooks: [
          {tracker: 'viewer',
            handler: 'dragHandler',
            hookHandler: function (event) {
            // if mobile disable drag event
            // pinch event handles panning with 2 fingers
              _self.$log.debug("dragHandler", event);
              _self.$log.debug("overlay true", event);
              _self.toggleOverlay()
              event.stopPropagation = true
              event.stopHandlers = true;
              setTimeout(function(){
                _self.toggleOverlay();
              }, 2000);
              return true;
            }},
        ]});

        // Finally, remove the instructions on any pinch event.
        // This covers both mouse and touch devices
        this.viewerImg.addViewerInputHook({ hooks: [
          {tracker: 'viewer',
            handler: 'pinchHandler',
            hookHandler: function (event) {
              _self.$log.debug("pinchHandler", event);
              return true;
            }},
        ]});

        var config = {};
        config["readOnly"] = true;
        config["widgets"] = ['COMMENT', { widget: 'TAG', vocabulary: [], showDelete: false }]
        config["image"] = this.viewerAnnos;
        config["formatters"] = [MyHighlightFormatter];
        this.annotoriousplugin = window.OpenSeadragon.Annotorious(this.viewerImg, config)
        Annotorious.SelectorPack(this.annotoriousplugin);
        this.annotoriousplugin.disableEditor = true
        if (this.item?.preSelected?.length > 0 && this.item?.preSelected[0] !== undefined){
          this.annotoriousplugin.setAnnotations(this.item.preSelected)
        }
      } else {
      }
    } else {
      this.noPicAvailable = true
    }
  }
};
</script>

<style scoped>
.resContainer {
  position: relative;
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.15); /* Leichter Schatten */
  border-radius: 8px; /* Abgerundete Ecken */
  overflow: hidden;
}
.container.hovered {
  box-shadow: 4px 8px 12px rgba(0, 0, 0, 0.3);
  transform: scale(1.05);
}

.nopic-container {
  height: 300px;
  background-color: lightgray;
}

.osd-viewer {
  width: 100%;
  height: 100%;
  background-color: white;
}
.overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;

  /* Mehr Platz für 2 Zeilen */
  min-height: 60px; /* vorher vermutlich ~40px */

  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.65) 20%,
    rgba(0, 0, 0, 0.55) 60%,
    rgba(0, 0, 0, 0.4) 75%,
    rgba(0, 0, 0, 0) 100%
  );

  color: white;
  padding: 10px 12px;

  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.loading-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.touch-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: transparent;
}
.overlay a {
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
  width: 100%;
  pointer-events: auto;
  margin-top: 10px;
}
.no-pic-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
}
.overlay-link {
  height: fit-content;
  display: block;
  width: 100%;
  text-align: center;
  color: white;
  text-decoration: none;
}
.overlay-slide-enter-active,
.overlay-slide-leave-active {
  transition: all .65s ease;
}

.overlay-slide-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.overlay-slide-enter-to {
  transform: translateY(0%);
  opacity: 1;
}

.overlay-slide-leave-from {
  transform: translateY(0%);
  opacity: 1;
}

.overlay-slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
.overlay-slide-appear-active {
  transition: transform 0.65s ease, opacity 0.65s ease;
}

.overlay-slide-appear-from {
  transform: translateY(100%);
  opacity: 0;
}

.overlay-slide-appear-to {
  transform: translateY(0%);
  opacity: 1;
}
</style>
